import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { activityLogActions } from 'components/activityLog/actions/activityLog';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
export const ConversationActivityLogButton = () => {
    const dispatch = useAppDispatch();
    const isActivityLogOpen = useAppSelector((state) => state.activityLog.isOpen);
    useCommandHandler({
        name: 'conversation:activityLog',
        actionFn: () => {
            toggleActivityLog();
        },
    });
    const toggleActivityLog = () => {
        const open = !isActivityLogOpen;
        dispatch(activityLogActions.toggle({ open }));
        if (open) {
            analytics.conversationActivityLogOpened({ context: 'conversation' });
        }
        else {
            analytics.conversationActivityLogClosed();
        }
    };
    const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:activityLog" }, { children: "Activity log" })));
    return (_jsx(Tooltip, Object.assign({ dark: true, content: tooltipContent }, { children: _jsx(IconButton, { "data-testid": "activity-log-button", icon: "activity", variant: "tertiary", active: isActivityLogOpen, onClick: toggleActivityLog }) })));
};
